module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department08-c3de6d8e83f4d1af9b4b143f0694242c.jpg";